import React, { useState } from "react";
import type * as types from "../PhoenixFormsV4";
import PhoenixFormsV4Control from "./PhoenixFormsV4Control";
import PhoenixFormsV4ReadOnlyControl from "./PhoenixFormsV4ReadOnlyControl";
import { Button } from "react-md";
import { classes } from "components/Utility";
import PNXLabel from "./PNXLabel";

interface Props {
  section: types.FormSection;
  readonly: boolean;
  headerOverride?: string;
};

const PhoenixFormsV4Section = (
  {
    section,
    readonly,
    headerOverride,
  }: Props
) => {
  console.log("PhoenixFormsV4Section Render");

  const [collapsed, setCollapsed] = useState(false);
  
  const onControlJump = () => {
    setCollapsed(false);
  };

  let mixedReadonly = section.controls.some(c => c.visible && c.readonly) && section.controls.some(c => c.visible && !c.readonly);

  return (
    <div className={classes("form-section", collapsed && "collapsed")}>
      <div className="section-title" onClick={() => setCollapsed(!collapsed)}>
        <Button icon className={classes("md-collapser", !collapsed && "md-collapser--flipped")}>
          keyboard_arrow_down
        </Button>
        <PNXLabel>{headerOverride ?? section.name}</PNXLabel>
      </div>
      <div className={classes("section-controls", mixedReadonly && "mixed-read-only-and-not")}>
        {section.controls.map(c => readonly ? 
          <PhoenixFormsV4ReadOnlyControl key={c.id} controlProps={c} /> : 
          <PhoenixFormsV4Control key={c.id} controlProps={c} onControlJump={onControlJump} />
          )}
      </div>
    </div>
  );
};

export default PhoenixFormsV4Section;